export const theme = {
  special: {
    1: '#FBC7D4',
    2: '#9796F0',
    3: '#7E50FF',
    4: 'linear-gradient(180deg, #FBC7D4 0%, #9796F0 100%)'
  },
  primary: {
    1: '#ECE5FF',
    2: '#DACDFF',
    3: '#C7B4FF',
    4: '#B59BFF',
    5: '#A282FF',
    6: '#9069FF',
    7: '#7E50FF'
  },
  gray: {
    white: '#FFFFFF',
    0: '#F9f9f9',
    1: '#E7E7E7',
    2: '#D9D9D9',
    2.5: '#BCBCBC',
    3: '#A5A5A5',
    3.5: '#7A7A7A',
    4: '#424242',
    black: '#1A1E27'
  },
  sub: {
    red: '#FF2C20',
    blue: '#0099FF',
    green: '#3CD456',
    yellow: '#FFB931',
    0: '#FAFBFB',
    1: '#F2F4F6',
    2: '#D9DFE0',
    3: '#7B7B7B',
    4: '#505866'
  }
};
